import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';
import _ from 'lodash';
import Color from '../../Color';

class Colors extends React.Component {
    renderColor(color, index, isCustomColor) {
        const isActive = _.isEqual(this.props.activeColor, color);
        const classes = ['menu__item'];
        let key = `color-${index}`;

        if (isActive) {
            classes.push('menu__item--active');
        }

        if (isCustomColor) {
            key = 'custom-' + key;
        }

        return (
            <li
                className={classes.join(' ')}
                key={key}
                onClick={() => this.props.setActiveColor(color)}
            >
                <Color color={color} isCustomColor={isCustomColor} />
            </li>
        );
    }

    renderCustomColorSelection() {
        return (
            <li className="menu__item">
                <div className="add-color" onClick={this.props.openColorPickerPopup}>
                    <Isvg src="/svg/add-color.svg" />
                </div>
            </li>
        );
    }

    renderCustomColors() {
        const { customColors } = this.props;
        return customColors.map((color, index) => this.renderColor(color, index, true));
    }

    render() {
        const { colors, allowCustomColors } = this.props;
        return (
            <div className="submenu__row color-selection">
                <ul className="menu">
                    {colors.map((color, index) => this.renderColor(color, index, false))}
                    {allowCustomColors ? this.renderCustomColorSelection() : null}
                    {allowCustomColors ? this.renderCustomColors() : null}
                </ul>
            </div>
        );
    }
}

Colors.propTypes = {
    colors: PropTypes.array.isRequired,
    activeColor: PropTypes.object,
    setActiveColor: PropTypes.func.isRequired,
    openColorPickerPopup: PropTypes.func,
    customColors: PropTypes.array,
    allowCustomColors: PropTypes.bool,
};

Colors.defaultProps = {
    customColors: [],
    activeColor: null,
    allowCustomColors: false,
    openColorPickerPopup: undefined,
};

export default Colors;
